import React from 'react';
import RichTextEditor from 'react-rte';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {toolbarConfig} from '../consts';

interface Props {
    value: string;
    onChange: (value: any) => void;
}

const Editor = ({value, onChange}: Props) => (
    <RichTextEditor
        autoFocus={true}
        value={value}
        onChange={onChange}
        placeholder={getLocalizedText(texts.RemarksPlaceholder)}
        toolbarClassName="RTE-toolbar"
        editorClassName="RTE-editor"
        toolbarConfig={toolbarConfig}
    />
);

export default Editor;
